import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useNewManualQuestion = ({ id }: { id: string }) => {
  const queryClient = useQueryClient();
  const trpc = useTRPC();
  return useMutation(
    trpc.questions.create.mutationOptions({
      onSuccess: (_, { id }) => {
        toast.success("Question added successfully");
        queryClient.invalidateQueries({
          queryKey: trpc.questions.getWithOptions.queryKey({ id }),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.progress.getStudySetProgress.queryKey({ id }),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.questions.getWithFileNames.queryKey({ id }),
        });
      },
      onError: (error) => {
        console.error("Failed to add question", error);
        toast.error(error.message);
      },
    }),
  );
};
